// src/components/layout/Layout.js
import React, { useContext } from 'react';
import { Box, Toolbar, AppBar, Typography, Button } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar.js';
import AuthContext from '../../context/AuthContext.js';
import { useLayout } from '../../context/LayoutContext.js';

const Layout = () => {
    const { logout, user } = useContext(AuthContext);
    const { headerTitle } = useLayout();
    const location = useLocation();

    // Pequeña función para obtener el título de la página actual
    const getPageTitle = () => {
        // Si hay un título personalizado, lo usamos.
        if (headerTitle) {
            return headerTitle;
        }
        // Si no, usamos la lógica de fallback que ya teníamos.
        const pathName = location.pathname.split('/').pop().replace('-', ' ');
        return pathName.charAt(0).toUpperCase() + pathName.slice(1);
    };
    
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box component="main" sx={{ flexGrow: 1, p: 3, width: `calc(100% - 240px)` }}>
                <AppBar 
                    position="fixed" 
                    sx={{ 
                        width: `calc(100% - 240px)`, 
                        ml: `240px`,
                        backgroundColor: 'white',
                        color: 'black',
                        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.1)'
                    }}
                >
                    <Toolbar>
                        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                            {getPageTitle()}
                        </Typography>
                        <Typography sx={{ mr: 2 }}>
                            Hola, {user?.fullname} 
        <Box component="span" sx={{ fontStyle: 'italic', color: 'gray', ml: 1 }}>
            ({user?.role})
        </Box>

              
                        </Typography>
                        <Button color="inherit" onClick={logout}>Cerrar Sesión</Button>
                    </Toolbar>
                </AppBar>
                <Toolbar /> {/* Un espacio para que el contenido no quede debajo del AppBar */}
                <Outlet /> {/* Aquí se renderizará el contenido de la página actual (Dashboard, etc.) */}
            </Box>
        </Box>
    );
};

export default Layout;